import type { Enums, Nullable } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getSupabaseIconName(name: Nullable<Enums<"iconName">>): IconName {
	switch (name) {
		case "arrow-up":
			return "ArrowUp";
		case "arrow-down":
			return "ArrowDown";
		case "arrow-left":
			return "ArrowLeft";
		case "arrow-right":
			return "ArrowRight";
		case "arrow-wave-left":
			return "Undo";
		case "arrow-wave-right":
			return "Redo";
		case "arrows-diff":
			return "ArrowRightLeft";
		case "arrows-split":
			return "ArrowLeftRight";
		case "arrows-random":
			return "Expand";
		case "bulb":
			return "Lightbulb";
		case "bolt":
			return "Bolt";
		case "circle":
			return "Circle";
		case "circle-dashed":
			return "CircleDashed";
		case "circle-dotted":
			return "CircleDotDashed";
		case "folder":
			return "FolderOpen";
		default:
			return "HelpCircle";
	}
}
